module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty15.287470dc.jpg";